module.exports = __webpack_public_path__ + "img/fifth.ca1a5408.jpg";